module.exports = __webpack_public_path__ + "static/media/BZN-truck.f49e9202.jpg";